__turbopack_context__.v({
  "columns": "aT5x4a_columns",
  "columns__col": "aT5x4a_columns__col",
});
